import { useState } from 'react';
import {
  Input,
  FormLabel,
  FormControl,
  InputRightElement,
  InputGroup,
  Image,
  Text,
} from "@chakra-ui/react"; 

const FormikInput = ({
  formik,
  label,
  name="",
  placeholder,
  isPassword,
  type,
  labelColor,
  labelSize,
  icon,
  disabled=false,
  color = "#000000",
  rightAdornment,
}) => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);



  const inputType = type ? type : !isPassword ? 'text' : isPasswordShown ? 'text' : 'password';

  return (
    <FormControl>
      <FormLabel
        color={labelColor ? labelColor : "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize ? labelSize : 12}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <Input
          name={name}
          value={formik && formik.values[name]}
          onChange={formik && formik.handleChange}
          type={inputType}
          placeholder={placeholder}
          bg={"transparent"}
          fontFamily={"PlusJakartaSansRegular"}
          borderRadius={"4px"}
          fontSize={"12px"}
          lineHeight={"20"}
          color={color}
          _placeholder={{ color: "#898989" }}
          isDisabled={disabled}
        />
        {icon && <InputRightElement >{icon}</InputRightElement>}
        {(icon || rightAdornment || isPassword) && (
          <InputRightElement height="48px">
            {isPassword ? (
              <span onClick={() => setIsPasswordShown((p) => !p)}>
                {isPasswordShown ? (
                  <Image src={require("../../assets/svgs/eye-crossed.svg").default} />
                ) : (
                  <Image src={require("../../assets/svgs/eye.svg").default} />
                )}
              </span>
            ) : (
              icon || rightAdornment
            )}
          </InputRightElement>
        )}
      </InputGroup>
      {formik && formik.touched[name] && formik.errors[name] ? (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily={"PlusJakartaSansRegular"}
          lineHeight={"20px"}
          mt={1}
        >
          {formik.errors[name]}
        </Text>
      ) : null}
    </FormControl>
  );
}

export default FormikInput;
